<template>
  <el-dialog
    title="新手指引"
    :visible.sync="dialogVisible"
    :width="dialogWidth"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    :modal-append-to-body="true"
    :append-to-body="true"
    class="finger-guide-dialog"
    :top="dialogTop"
  >
    <div class="guide-content">
      <div v-html="parsedMarkdown" class="markdown-body" ref="markdownBody"></div>
    </div>
    
    <el-image
      ref="previewImage"
      :src="previewSrcList.length > 0 ? previewSrcList[0] : ''"
      :preview-src-list="previewSrcList"
      :initial-index="previewIndex"
      style="display: none;"
    />
  </el-dialog>
</template>

<script>
import { marked } from 'marked'

export default {
  name: 'FingerGuideDialog',
  data() {
    return {
      dialogVisible: false,
      markdownContent: '',
      _previewIndex: 0,
      previewSrcList: []
    }
  },
  computed: {
    parsedMarkdown() {
      return marked.parse(this.markdownContent)
    },
    isMobile() {
      return window.innerWidth <= 768
    },
    dialogWidth() {
      return this.isMobile ? '95%' : '900px'
    },
    dialogTop() {
      return this.isMobile ? '8vh' : '5vh'
    },
    previewIndex: {
      get() {
        return this._previewIndex || 0
      },
      set(value) {
        this._previewIndex = value
        this.$nextTick(() => {
          if (this.$refs.previewImage) {
            this.$refs.previewImage.clickHandler()
            this.$nextTick(() => {
              const viewer = document.querySelector('.el-image-viewer__wrapper')
              if (viewer) {
                const nextBtn = viewer.querySelector('.el-image-viewer__next')
                if (nextBtn) {
                  for (let i = 0; i < value; i++) {
                    nextBtn.click()
                  }
                }
              }
            })
          }
        })
      }
    }
  },
  mounted() {
    this.configureMarked()
  },
  methods: {
    configureMarked() {
      marked.setOptions({
        breaks: true,
        gfm: true
      })
    },
    async open() {
      this.dialogVisible = true
      await this.loadMarkdown()
    },
    close() {
      this.dialogVisible = false
    },
    async loadMarkdown() {
      try {
        const response = await fetch('/guide.md')
        const text = await response.text()
        this.markdownContent = text
        this.$nextTick(() => {
          this.replaceImagesWithElImage()
          this.$nextTick(() => {
            const images = this.$refs.markdownBody ? this.$refs.markdownBody.querySelectorAll('img') : []
            this.previewSrcList = Array.from(images).map(img => img.src)
          })
        })
      } catch (error) {
        console.error('[FingerGuideDialog] 加载Markdown失败:', error)
        this.$message.error('加载新手指引失败')
      }
    },
    replaceImagesWithElImage() {
      const images = this.$el.querySelectorAll('.markdown-body img')
      images.forEach((img, index) => {
        const src = img.getAttribute('src')
        const alt = img.getAttribute('alt') || '图片'
        
        const elImage = document.createElement('div')
        elImage.className = 'el-image-wrapper'
        
        const imageEl = document.createElement('img')
        imageEl.src = src
        imageEl.alt = alt
        imageEl.className = 'guide-image'
        imageEl.onclick = () => {
          this.previewIndex = index
        }
        
        elImage.appendChild(imageEl)
        img.parentNode.replaceChild(elImage, img)
      })
    }
  }
}
</script>

<style>
.guide-content {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

.markdown-body {
  line-height: 1.8;
  color: #303133;
}

.markdown-body h1 {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #409EFF;
}

.markdown-body h2 {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin-top: 30px;
  margin-bottom: 15px;
  padding-left: 10px;
  border-left: 4px solid #409EFF;
}

.markdown-body h3 {
  font-size: 20px;
  font-weight: bold;
  color: #303133;
  margin-top: 25px;
  margin-bottom: 12px;
}

.markdown-body p {
  margin-bottom: 15px;
  text-align: justify;
}

.markdown-body ul,
.markdown-body ol {
  margin-bottom: 15px;
  padding-left: 25px;
}

.markdown-body li {
  margin-bottom: 8px;
  line-height: 1.6;
}

.markdown-body strong {
  color: #409EFF;
  font-weight: bold;
}

.markdown-body code {
  background-color: #f5f7fa;
  color: #e6a23c;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
}

.markdown-body pre {
  background-color: #f5f7fa;
  padding: 15px;
  border-radius: 5px;
  overflow-x: auto;
  margin-bottom: 15px;
}

.markdown-body pre code {
  background-color: transparent;
  color: #303133;
  padding: 0;
}

.markdown-body blockquote {
  border-left: 4px solid #409EFF;
  padding-left: 15px;
  margin: 15px 0;
  color: #909399;
  background-color: #f5f7fa;
  padding: 10px 15px;
  border-radius: 5px;
}

.markdown-body hr {
  border: none;
  border-top: 1px solid #dcdfe6;
  margin: 30px 0;
}

.el-image-wrapper {
  margin: 20px 0;
  text-align: center;
}

.guide-image {
  max-width: 300px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s ease;
}

.guide-image:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.finger-guide-dialog .el-dialog {
  z-index: 99999 !important;
}

.finger-guide-dialog .el-dialog__wrapper {
  z-index: 99998 !important;
}

.finger-guide-dialog .v-modal {
  z-index: 99997 !important;
}
</style>
